import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import TemasAcademicosView from './TemasAcademicosView';
import * as ROUTES from '../../../router/Routes';

const TemasAcademicosModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.temasAcademicos}
      routes={[ROUTES.academico]}
    >
      <TemasAcademicosView />
    </ContainerTemplate>
  );
};

export default TemasAcademicosModule;
